import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " District Wise Training Report ")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tranche")
], -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Ethnicity", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "col-md-2 mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex pt-4 pb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "fs-4 text-gray-600" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "mt-2" })
      ])
    ])
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_17 = { class: "position-relative" }
const _hoisted_18 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#courseTReport",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, " District Wise Training Report ")
  ])
], -1)
const _hoisted_20 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_21 = { class: "collapse show" }
const _hoisted_22 = {
  class: "card-body border-top p-4",
  style: {"overflow":"scroll"}
}
const _hoisted_23 = { class: "row w-100 mb-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_25 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-5",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-5",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-5",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_29 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","font-weight":"bold"},
      rowspan: "2"
    }, " Name of Division "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","font-weight":"bold"},
      rowspan: "2"
    }, " Name of District "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","font-weight":"bold"},
      colspan: "3"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","font-weight":"bold"},
      colspan: "3"
    }, " Assesment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","font-weight":"bold"},
      colspan: "3"
    }, " Dropout "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","font-weight":"bold"},
      colspan: "3"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center","font-weight":"bold"},
      colspan: "3"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Male "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Male "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Male "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Male "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Total "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Male "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold"} }, " Female ")
  ])
], -1)
const _hoisted_31 = { style: {} }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "font-weight-bold",
  style: {"text-align":"center","font-weight":"bold"}
}, " Total: ", -1)
const _hoisted_33 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold;"
}
const _hoisted_34 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_35 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_36 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_37 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_38 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_39 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_40 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_41 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_42 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_43 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_44 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_45 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_46 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}
const _hoisted_47 = {
  style: {"text-align":"center","font-weight":"bold"},
  class: "font-weight-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                      options: _ctx.tranches_info,
                      mode: "tags",
                      "clear-on-select": false,
                      placeholder: "Select Tranche",
                      "close-on-select": false,
                      searchable: true,
                      "create-option": true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Ethnicity",
                      modelValue: _ctx.ethnic_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ethnic_id) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "--Select--",
                          value: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" --Select--")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Ethnic Minority",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Ethnic Minority")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "All",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" All")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.districtTrainee())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_14
                    ])
                  ])
                ]),
                _hoisted_15,
                _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-dark fs-7 p-2 rounded-0",
                                  title: "Download Xlse",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportTrainee()))
                                }, [
                                  _hoisted_26,
                                  _createTextVNode(" Excel ")
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-warning fs-7 p-2 rounded-0",
                                  title: "Download PDF",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadPdf()))
                                }, [
                                  _hoisted_27,
                                  _createTextVNode(" PDF ")
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-dark fs-7 p-2 rounded-0",
                                  title: "Print",
                                  "data-v-54b12dc8": "",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printPdf()))
                                }, [
                                  _hoisted_28,
                                  _createTextVNode(" Print ")
                                ])
                              ])
                            ]),
                            _createElementVNode("table", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("tbody", _hoisted_31, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.traineeDistrictData, (data, inx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: inx,
                                    class: "border border-gray-400 text-center"
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(data?.division_name_eng), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.district_name_eng), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.total), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.male), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.female), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.training_assessments_total), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.assest_male), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.assest_female), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.dropout_total), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.male_dropout), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.female_dropout), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.total_certificates), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.certificate_male), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.certificate_female), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.employment_total), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.employment_male), 1),
                                    _createElementVNode("td", null, _toDisplayString(data?.employment_female), 1)
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.total_sum_district, (data, inx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: inx,
                                    class: "border border-gray-400 text-center"
                                  }, [
                                    _hoisted_32,
                                    _createElementVNode("td", _hoisted_33, _toDisplayString(data?.total), 1),
                                    _createElementVNode("td", _hoisted_34, _toDisplayString(data?.male), 1),
                                    _createElementVNode("td", _hoisted_35, _toDisplayString(data?.female), 1),
                                    _createElementVNode("td", _hoisted_36, _toDisplayString(data?.training_assessments_total), 1),
                                    _createElementVNode("td", _hoisted_37, _toDisplayString(data?.assest_male), 1),
                                    _createElementVNode("td", _hoisted_38, _toDisplayString(data?.assest_female), 1),
                                    _createElementVNode("td", _hoisted_39, _toDisplayString(data?.dropout_total), 1),
                                    _createElementVNode("td", _hoisted_40, _toDisplayString(data?.male_dropout), 1),
                                    _createElementVNode("td", _hoisted_41, _toDisplayString(data?.female_dropout), 1),
                                    _createElementVNode("td", _hoisted_42, _toDisplayString(data?.total_certificates), 1),
                                    _createElementVNode("td", _hoisted_43, _toDisplayString(data?.certificate_male), 1),
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(data?.certificate_female), 1),
                                    _createElementVNode("td", _hoisted_45, _toDisplayString(data?.employment_total), 1),
                                    _createElementVNode("td", _hoisted_46, _toDisplayString(data?.employment_male), 1),
                                    _createElementVNode("td", _hoisted_47, _toDisplayString(data?.employment_female), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])), [
                        [_directive_loading, _ctx.load]
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}